const HelpCenter = () => {
  return (
    <div>
      <p>HelpCenter</p>
    </div>
  );
};

export default HelpCenter;
